var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.26837 0 0 6.26837 0 14C0 21.7316 6.26837 28 14 28C21.7316 28 28 21.7316 28 14C28 6.26837 21.7316 0 14 0ZM20.5739 18.9202C18.9538 17.2234 17.1069 16.3167 13.2657 16.3167V18.8287C13.2652 18.938 13.2328 19.0448 13.1724 19.136C13.112 19.2271 13.0262 19.2985 12.9256 19.3415C12.825 19.3844 12.7141 19.397 12.6065 19.3776C12.4989 19.3583 12.3993 19.3078 12.32 19.2325L6.63519 13.8654C6.58039 13.8138 6.53672 13.7515 6.50687 13.6824C6.47702 13.6133 6.46163 13.5388 6.46163 13.4636C6.46163 13.3883 6.47702 13.3138 6.50687 13.2447C6.53672 13.1756 6.58039 13.1133 6.63519 13.0617L12.3173 7.6926C12.3966 7.61729 12.4962 7.56684 12.6038 7.54747C12.7114 7.5281 12.8224 7.54067 12.9229 7.58361C13.0235 7.62656 13.1093 7.698 13.1697 7.78913C13.2301 7.88027 13.2626 7.9871 13.263 8.09644V10.6084C19.2352 10.6084 21.1663 14.3534 21.5331 18.4894C21.5822 19.009 20.9374 19.3005 20.5739 18.9202Z",
    fill: "#89A7E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBackArrow);
export default __webpack_public_path__ + "static/media/blue-back-arrow.a3b17845.svg";
export { ForwardRef as ReactComponent };